export const APP_FETCH_SERVER_PROPS = 'APP_FETCH_SERVER_PROPS';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/ReactApp/ReactAppConstants.js